import { Component, OnInit, HostBinding } from '@angular/core';
import { IPolicies } from '../../shared/models/policies.interface';
import { LoginService } from '../../services/login.service';
import { UserService } from 'src/app/services/user.service';
import { TaggingService } from 'src/app/tags/tagging.service';
import { AccountInfo } from 'src/app/shared/models/account-info.interface';
import { PolicyService } from 'src/app/services/policy.service';

@Component({
  selector: 'upsc-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  @HostBinding('class') public hostClass = 'profile';

  public policy: IPolicies;
  userDetails: AccountInfo;
  public securityActive: boolean = false;
  isCanadaUser: boolean;
  isInternalUser: boolean = false

  //Roles
  isClaimViewer: boolean = false;
  isFileClaim: boolean = false;
  isThreeContractNo: boolean = false;
  isContract: boolean = false;

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private taggingService: TaggingService,
    private policyService: PolicyService
  ) {
    this.policy = this.loginService.getPolicyDetails();
    this.isCanadaUser = this.userService.isCanadaUser();
    this.userDetails = this.userService.getUserInfo();
    this.isClaimViewer = this.userService.getUserPermissions()?.isClaimView;  //ClaimViewer cannot click file claim button
    this.isFileClaim = this.userService.getUserPermissions()?.isFileClaim;
    this.isThreeContractNo = this.policyService.isThreeHyphenContractNo();
  }

  ngOnInit() {
    this.taggingService.view();

    let isInternal = this.userDetails.internalUser;
    if (isInternal) {
      this.isInternalUser = true;
    } else {
      this.isInternalUser = false;
    }

    this.isContractOrPolicyType();
  }

  isContractOrPolicyType () {
    if (this.policy?.policyTypeIndicator === "Contract") {
      this.isContract = true;
    }
  }
  tagging() {
    this.taggingService.link({ link_name: 'file_a_claim' });
  }
}
